import PropTypes from "prop-types";
import React from "react";

const NoPermission = (props) => {
  const { isSending, submitRequest, requestStatus } = props;

  return (
    <div className="nip-overlay">
      <div className="nip-overlay-box">
        <h1>No Access</h1>
        <p>
          You don't have access to fill the IP Permit form. Please request
          network admin to fill out the form
        </p>
        {!requestStatus ? (
          <h6 data-testid="submitRequest" onClick={() => submitRequest()}>
            {isSending ? "SENDING REQUEST..." : "SEND REQUEST"}
          </h6>
        ) : (
            <h6>REQUEST SUBMITTED SUCCESSFULLY</h6>
          )}
      </div>
    </div>
  );
};

NoPermission.propTypes = {
  isSending: PropTypes.any,
  requestStatus: PropTypes.any,
  submitRequest: PropTypes.func
}

export default NoPermission;
